import React from 'react';
import PropTypes from 'prop-types';
import './styles/app.css';
import { ThemeProvider } from '@womcorp/wom-miwom-ui-kit/dist/@theme';
import AppRouter from './AppRouter';
import packageInfo from '../../../package.json';

global.debugVersion = {
  environment: process.env.NODE_ENV,
  siteVersion: packageInfo.version,
};

const App = ({ children, location }) => (
  <ThemeProvider normalize={false}>
    <AppRouter location={location}>{children}</AppRouter>
  </ThemeProvider>
);

App.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.instanceOf(Object).isRequired,
};

export default App;
